import React from 'react'
import styled from 'styled-components'
import { Link } from 'gatsby'
import { FiChevronDown, FiChevronRight } from 'react-icons/fi'
import secundarioMetadata from '../../hooks/QueryMenuSecundario'
import flatListToHierarchical from '../../util/flatListToHierarchical'
import { device } from '../Breakpoints'

const Container = styled.nav`
  background: #499490;
  width: 100%;
  display: flex;
  padding-left: 1.5em;
  @media ${device.laptopL} {
    padding-left: 0em;
  }
  .menu {
    > li {
      a {
        text-align: center;
      }
    }
  }
  ul {
    margin: 0;
    padding: 0;
    display: flex;
    max-height: 50px;
    li {
      margin: 0;
      padding: 0;
      list-style: none;
      height: 100%;
      align-items: center;
      display: flex;
      position: relative;
      :hover {
        background: #1d716b;
        > .submenu {
          display: block;
        }
      }

      a {
        align-items: center;
        display: flex;
        height: 18px;
      }
      .submenu {
        display: none;
        position: absolute;
        left: 0;
        top: 50px;
        min-width: 250px;
        background: #1d716b;
        padding: 1em;
        box-sizing: border-box;
        z-index: 9998;
        max-height: fit-content;
        li:last-child > a {
          border-bottom: none;
        }
        li {
          a {
            text-align: left !important;
          }
        }
        svg {
          height: 15px;
          width: 20px;
        }
        .submenu {
          left: 100%;
          top: 0px;
          li:last-child a {
            border-bottom: none;
          }
        }
        @media all and (-ms-high-contrast: none), (-ms-high-contrast: active), {
          /**
              Target IE11
              */
          width: 100px !important;
          max-height: 670px !important;
        }
        @supports (-ms-ime-align: auto) {
          /**
              Target Edge
              */
          width: 120px !important;
          max-height: 500px !important;
        }
        li {
          @media all and (-ms-high-contrast: none),
            (-ms-high-contrast: active) {
            /**
              Target IE11
              */
            height: auto !important;
            display: block !important;
          }
          @supports (-ms-ime-align: auto) {
            /**
              Target Edge
              */
            height: auto !important;
            display: block !important;
          }

          a {
            padding: 1em 0.5em;
            display: flex;
            justify-content: space-between;
            font-size: 0.65em;
            height: 100%;
            width: 100%;
            border-bottom: 1px solid rgba(255, 255, 255, 0.1);
            :hover {
              background: #499490;
            }
            @media all and (-ms-high-contrast: none),
              (-ms-high-contrast: active) {
              /**
              Target IE11
              */
              width: auto !important;
            }
            @supports (-ms-ime-align: auto) {
              /**
              Target Edge
              */
              width: auto !important;
            }
          }
        }
      }
    }
    @media ${device.laptopL} {
      li.last {
        .submenu {
          left: inherit !important;
          right: 0;
        }
      }
    }
  }

  button {
    align-items: center;
    display: flex;
    height: 58px;
    cursor: pointer;
    border: none;
    background: transparent;
    color: #ffffff;
    text-transform: uppercase;
    font-size: 0.7em;
    padding: 10px 19px;
    svg {
      vertical-align: bottom;
      margin-left: 5px;
      font-size: 13px;
      @media ${device.laptopL} {
        margin-left: 2px;
      }
    }
  }
  a {
    color: #ffffff;
    text-decoration: none;
    font-family: 'Santral', Arial, Helvetica, sans-serif;
    text-transform: uppercase;
    font-size: 0.7em;
    padding: 10px 19px;
    @media ${device.laptopL} {
      padding: 10px 19px;
    }
    svg {
      vertical-align: bottom;
      margin-left: 5px;
      font-size: 13px;
      @media ${device.laptopL} {
        margin-left: 2px;
        width: 19px;
        height: 14px;
      }
    }
    :hover {
      background: #1d716b;
    }
  }
`
const click = item => {
  if (item === 'Ensino e Pesquisa') {
    window.open('https://gruposantajoana.com.br/ensinoepesquisa', '_blank')
  }
  return false
}

const MenuSecundario = () => {
  const menu = secundarioMetadata()
  const menuData = flatListToHierarchical(menu)
  return (
    <Container>
      <ul className="menu">
        {menuData.map((item, index) => (
          <li
            key={item.order}
            className={menuData.length === index + 1 ? 'last' : ''}
          >
            {item.url === '#' ? (
              <button
                type="button"
                className={item.url.replace('/', ' ')}
                onClick={() => click(item.label)}
              >
                {item.label}
                {item.childItems.nodes ? <FiChevronDown size="1.5em" /> : ''}
              </button>
            ) : (
              <Link to={item.url} className={item.url.replace(/\//g, '')}>
                {item.label}
                {item.childItems.nodes ? <FiChevronDown size="1.5em" /> : ''}
              </Link>
            )}

            {item.childItems.nodes.length !== 0 ? (
              <ul className="submenu">
                {item.childItems.nodes.map(child => (
                  <li key={child.order}>
                    {child.connectedNode === null ? (
                      <a href={child.url} target="_blank" rel="noreferrer">
                        {child.label}
                        {child.childItems.nodes.length !== 0 && (
                          <FiChevronRight />
                        )}
                      </a>
                    ) : (
                      <Link
                        to={child.url}
                        state={{ area: item.label }}
                        className={child.url.replace('/', ' ')}
                      >
                        {child.label}
                        {child.childItems.nodes.length !== 0 && (
                          <FiChevronRight />
                        )}
                      </Link>
                    )}
                    {child.childItems.nodes.length !== 0 ? (
                      <ul className="submenu">
                        {child.childItems.nodes.map(child2 => (
                          <li key={child2.order}>
                            {child2.connectedNode === null ? (
                              <a
                                href={child2.url}
                                target="_blank"
                                rel="noreferrer"
                              >
                                {child2.label}
                              </a>
                            ) : (
                              <Link
                                to={child2.url}
                                state={{ area: item.label }}
                              >
                                {child2.label}
                              </Link>
                            )}
                          </li>
                        ))}
                      </ul>
                    ) : (
                      ''
                    )}
                  </li>
                ))}
              </ul>
            ) : (
              ''
            )}
          </li>
        ))}
      </ul>
    </Container>
  )
}

export default MenuSecundario
